// import { jwtDecode } from "jwt-decode";

export function getName() {
  const admin = JSON.parse(localStorage.getItem("admin-info"));
  return admin;
}

// export function getNameTwo() {
//   const adminInfo = JSON.parse(localStorage.getItem("admin-info"));
//   if (adminInfo && adminInfo.token) {
//     try {
//       const decodedToken = jwtDecode(adminInfo.token);
//       return decodedToken; // This will return the decoded payload (e.g., user information)
//     } catch (error) {
//       console.error("Invalid token", error);
//       return null;
//     }
//   }
//   return null;
// }

// dateUtils.js
export function formatDateToISO(dateInput) {
  const date = new Date(dateInput);
  return date.toISOString().replace("T", " ").substring(0, 19);
}
